export default "__VITE_ASSET__DITLHCES__"